export const baseUrl = window.location.origin;
export const redirectUrl = `${baseUrl}/callback`;

export const appId = '4va65wlazq2rpe4dg42lk'; // Register the sample app in Logto dashboard
export const endpoint = 'https://vt9dp4.logto.app/'; // Replace with your own Logto endpoint
